import * as React from 'react';
import { NumberField } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';

import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

import { getDefaultTravelTimeForType } from '../../../../../../../utils/underground';
import { EMetroTravelType } from '../../../../../../../json_query';
import { InlineParam, InlineLabel } from '../../../markup';

import * as styles from './styles.css';

export interface IUndergroundTimeProps {
  travelType: EMetroTravelType;
  travelTime: number | undefined;

  onUndergroundTravelChange(travelType: EMetroTravelType, travelTime: number | undefined): void;
}

const TRAVEL_TYPE_OPTIONS: IDropdownValue[] = [
  { value: EMetroTravelType.Any, label: 'Неважно' },
  { value: EMetroTravelType.MapFoot, label: 'Пешком' },
  { value: EMetroTravelType.MapTransport, label: 'Транспортом' },
];

export class UndergroundTime extends React.Component<IUndergroundTimeProps> {
  public render() {
    const travelTime = this.props.travelTime || getDefaultTravelTimeForType(this.props.travelType);

    return (
      <>
        <InlineParam>
          <DropdownField
            value={this.props.travelType}
            onValueChange={this.handleTravelTypeChange}
            values={TRAVEL_TYPE_OPTIONS}
            buttonStyle={styles['dropdown']}
          />
        </InlineParam>
        {this.props.travelType !== EMetroTravelType.Any && (
          <InlineParam>
            <InlineLabel>Не более:</InlineLabel>
            <InlineLabel>
              <NumberField
                disableFractional
                disableNegative
                inputStyle={{ width: '60px' }}
                value={travelTime}
                onValueChange={this.handleChangeTravelType}
              />
            </InlineLabel>
            {(travelTime && plural(travelTime, ['минута', 'минуты', 'минут'])) || 'минут'}
          </InlineParam>
        )}
      </>
    );
  }

  private handleTravelTypeChange = (value: EMetroTravelType) => {
    this.props.onUndergroundTravelChange(value, this.props.travelTime || getDefaultTravelTimeForType(value));
  };

  private handleChangeTravelType = (value: number | undefined) => {
    this.props.onUndergroundTravelChange(this.props.travelType, value);
  };
}
